<template>
<span class="d-inline-block border-radius pipeline-compact-state-viewer" :style="{backgroundColor: color}">
  {{ state }}
</span>
</template>

<script>
import {getMappedTask} from "@/pipelineUtils";
import {TaskManagerStates, TaskManagerTaskColors, VMLogStates} from "@/enum";

export default {
  name: "PipelineCompactStateViewer",
  props: {
    // an item can be: an asset, an instance, both have to have taskManagerRows (or an empty array if not available)
    item: {type: Object, default: () => {}}
  },
  data() {
    return {
      TaskManagerTaskColors,
      TaskManagerStates,
      VMLogStates
    }
  },
  computed: {
    taskEntries() {
      return this.item ? this.item.taskManagerRows : null;
    },
    taskEntry() {
      return this.taskEntries && this.taskEntries[0] ? this.taskEntries[0] : null;
    },
    vmlogEntries() {
      return this.item ? this.item.vmLogs : null;
    },
    newestVMLogEntry() {
      if(!this.vmlogEntries || this.vmlogEntries.length === 0) {
        return null;
      }
      let newest = this.vmlogEntries[0];
      for(const logEntry of this.vmlogEntries) {
        if(new Date(logEntry.createdAt) > new Date(newest.createdAt)) {
          newest = logEntry;
        }
      }
      return newest;
    },
    mappedTask() {
      return getMappedTask(this.taskEntry);
    },
    color() {
      const prio = this.computedPrio;
      if(!this.mappedTask) {
        const {state} = this.item;
        if(prio) {
          return TaskManagerTaskColors[prio];
        }
        return state === 'a' ? 'green' : 'grey';
      }
      return this.mappedTask ? TaskManagerTaskColors[this.computedPrio] : '';
    },
    computedPrio() {
      let prioNumber = this.mappedTask ? this.mappedTask.prio : null;
      if(prioNumber > 0 && prioNumber < 100) {
        prioNumber = 1;
      }
      // if prioNumber is null or undefined: use vmlog (if available) to determine state
      if((prioNumber === null || prioNumber === undefined) && this.newestVMLogEntry) {
        const logState = this.newestVMLogEntry.state;
        switch (logState) {
          case VMLogStates.STARTED: // this basically means: somebody deleted the task, so it isn't running anymore
            prioNumber = 779;
            break;
          case VMLogStates.ERRORED:
            prioNumber = 666;
            break;
          case VMLogStates.FINISHED:
            prioNumber = 0;
            break;
          default:
            prioNumber = null;
        }
      }
      return prioNumber;
    },
    state() {
      const prio = this.computedPrio;
      if(!this.mappedTask) {
        const {state} = this.item;
        if(prio) {
          return TaskManagerStates[prio];
        }
        return state === 'a' ? 'ready' : 'not ready';
      }
      return this.mappedTask ? 'pipeline: ' + TaskManagerStates[this.computedPrio] : '';
    },
  }
}
</script>

<style scoped lang="scss">
.pipeline-compact-state-viewer {
  padding: 1px 5px;
  font-weight: bold;
  font-size: 0.9rem;
}
</style>